import { TokenCredential, AccessToken } from "@azure/core-auth";

type TokenProvider = () => Promise<string>;

export class MsalTokenCredential implements TokenCredential {
    constructor(private readonly getTokenFn: TokenProvider) { }

    async getToken(_scopes: string | string[]): Promise<AccessToken | null> {
        const token = await this.getTokenFn();
        const expiresOnTimestamp = Date.now() + 3600000; // fake 1 hour for demo

        return {
            token,
            expiresOnTimestamp,
        };
    }
}
